import React from 'react';

export const ShutterRightFold = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 106.9 77.8"
      width="85"
      {...props}
    >
      <path fill="#fff" d="M5.6.8h95.8v67.8H5.6z" />
      <path
        d="M101.3 69.3H5.6c-.4 0-.8-.3-.8-.8V.8c0-.5.3-.8.8-.8h95.8c.4 0 .8.3.8.8v67.8c-.1.4-.4.7-.9.7zM6.4 67.8h94.2V1.6H6.4v66.2z"
        fill="#dcd9d5"
      />
      <path fill="#fff" d="M5.6.8h95.8v67.8H5.6z" />
      <path
        d="M101.3 69.3H5.6c-.4 0-.8-.3-.8-.8V.8c0-.5.3-.8.8-.8h95.8c.4 0 .8.3.8.8v67.8c-.1.4-.4.7-.9.7zM6.4 67.8h94.2V1.6H6.4v66.2z"
        fill="#dcd9d5"
      />
      <g fill="#dcd9d5">
        <path d="M10 5.3h86.8v58.8H10z" />
        <path d="M96.9 64.9H10c-.4 0-.8-.3-.8-.8V5.3c0-.4.3-.8.8-.8h86.8c.4 0 .8.3.8.8v58.8c.1.4-.3.8-.7.8zm-86.1-1.6h85.3V6H10.8v57.3z" />
      </g>
      <path
        d="M106.2 69.3H.7c-.4 0-.7-.3-.7-.7 0-.4.3-.7.7-.7h105.4c.4 0 .7.3.7.7.1.4-.2.7-.6.7z"
        fill="#dcd9d5"
      />
      <g>
        <path fill="#233762" d="M26.1 1.7l36.2 8.4.2 66.7-36.4-9.1z" />
        <path
          d="M63.1 77.8l-37.7-9.4V.7L63 9.4l.1 68.4zM26.8 67l35.1 8.7-.2-65-35-8.1.1 64.4z"
          fill="#fff"
        />
        <path fill="#233762" d="M29.9 9.5l28.8 6.8V21l-28.8-6.7z" />
        <path
          d="M59 21.6l-29.4-6.9V9.1L59 15.9v5.7zm-28.7-7.7l28.1 6.6v-3.9L30.3 10v3.9z"
          fill="#fff"
        />
        <path fill="#233762" d="M29.9 14.3L58.7 21v4.8L29.9 19z" />
        <path
          d="M59 26.3l-29.4-7v-5.6l29.4 7v5.6zm-28.7-7.6l28.1 6.6v-3.9l-28.1-6.6v3.9z"
          fill="#fff"
        />
        <path fill="#233762" d="M29.9 19l28.8 6.8v4.8l-28.8-6.8z" />
        <path
          d="M59.1 31.1l-29.4-7v-5.6l29.4 7v5.6zm-28.8-7.7l28.1 6.7v-3.9l-28.1-6.7v3.9z"
          fill="#fff"
        />
        <path fill="#233762" d="M29.9 23.8l28.8 6.8v4.8l-28.8-6.9z" />
        <path
          d="M59.1 35.9l-29.4-7v-5.6l29.4 7v5.6zm-28.8-7.7l28.1 6.7V31l-28.1-6.7v3.9z"
          fill="#fff"
        />
        <path fill="#233762" d="M29.9 28.5l28.8 6.9v4.8l-28.8-6.9z" />
        <path
          d="M59.1 40.7l-29.5-7.1V28L59 35l.1 5.7zm-28.8-7.8l28.1 6.8v-3.9l-28.1-6.7v3.8z"
          fill="#fff"
        />
        <path fill="#233762" d="M29.9 33.3l28.8 6.9V45l-28.8-6.9z" />
        <path
          d="M59.1 45.5l-29.5-7.1v-5.6l29.5 7.1v5.6zm-28.8-7.8l28.1 6.8v-3.9l-28.1-6.8v3.9z"
          fill="#fff"
        />
        <g>
          <path fill="#233762" d="M29.9 38.1L58.7 45l.1 4.8-28.8-7z" />
          <path
            d="M59.1 50.3l-29.5-7.2v-5.6l29.5 7.1v5.7zm-28.8-7.8l28.1 6.8v-3.9l-28.1-6.8v3.9z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M30 42.8l28.8 7v4.8l-28.8-7z" />
          <path
            d="M59.1 55.1l-29.5-7.2v-5.6l29.5 7.2v5.6zm-28.8-7.9l28.1 6.9v-3.9l-28.1-6.8v3.8z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M30 47.6l28.8 7v4.8L30 52.3z" />
          <path
            d="M59.1 59.9l-29.5-7.2v-5.6l29.5 7.2v5.6zM30.3 52l28.2 6.9V55l-28.1-6.9-.1 3.9z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M30 52.4l28.8 7.1v4.8L30 57.1z" />
          <path
            d="M59.1 64.8l-29.5-7.3v-5.6l29.5 7.2v5.7zm-28.8-8l28.2 6.9v-3.9l-28.2-6.9v3.9z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M30 57.1l28.8 7.2v4.8L30 61.9z" />
          <path
            d="M59.1 69.6l-29.5-7.3v-5.6L59.1 64v5.6zm-28.8-8l28.2 7v-3.9l-28.2-6.9v3.8z"
            fill="#fff"
          />
        </g>
        <path fill="#fff" d="M43.4 12.7l1.9.4.1 52.6-1.9-.4z" />
      </g>
      <g>
        <path fill="#233762" d="M63.8 9.7l37.1-8v66l-37.1 9.1z" />
        <path
          d="M101.5 68.4l-38.4 9.4V9L101.5.7v67.7zm-37 7.4l35.8-8.7V2.6l-35.8 7.8v65.4z"
          fill="#fff"
        />
        <path fill="#233762" d="M67.8 15.9l29.4-6.4v4.7l-29.4 6.5z" />
        <path
          d="M97.6 14.6l-30.1 6.7v-5.7L97.6 9v5.6zm-29.4 5.6l28.7-6.4V10l-28.7 6.3v3.9z"
          fill="#fff"
        />
        <path fill="#233762" d="M67.8 20.7l29.4-6.5V19l-29.4 6.6z" />
        <path
          d="M97.6 19.3L67.5 26v-5.7l30.1-6.7v5.7zM68.2 25l28.7-6.4v-3.9l-28.7 6.4V25z"
          fill="#fff"
        />
        <path fill="#233762" d="M67.8 25.6L97.2 19v4.7l-29.4 6.7z" />
        <path
          d="M97.6 24.1l-30.1 6.8v-5.7l30.1-6.7v5.6zm-29.4 5.8l28.7-6.5v-3.9l-28.7 6.4v4z"
          fill="#fff"
        />
        <path fill="#233762" d="M67.8 30.4l29.4-6.6v4.7l-29.4 6.7z" />
        <path
          d="M97.6 28.9l-30.1 6.9v-5.7l30.1-6.8v5.6zm-29.4 5.8l28.7-6.5v-3.9l-28.7 6.5v3.9z"
          fill="#fff"
        />
        <path fill="#233762" d="M67.8 35.2l29.4-6.7v4.8L67.8 40z" />
        <path
          d="M97.6 33.6l-30.1 6.9v-5.7L97.6 28v5.6zm-29.4 5.9l28.7-6.6V29l-28.7 6.6v3.9z"
          fill="#fff"
        />
        <path fill="#233762" d="M67.8 40l29.4-6.7V38l-29.4 6.9z" />
        <path
          d="M97.6 38.4l-30.1 7v-5.7l30.1-6.9v5.6zm-29.4 6l28.7-6.7v-3.9l-28.7 6.6v4z"
          fill="#fff"
        />
        <g>
          <path fill="#233762" d="M67.8 44.9L97.2 38v4.8l-29.4 6.9z" />
          <path
            d="M97.6 43.2l-30.1 7v-5.7l30.1-7v5.7zm-29.4 6l28.7-6.7v-3.9l-28.7 6.7v3.9z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M67.8 49.7l29.4-6.9v4.8l-29.4 6.9z" />
          <path
            d="M97.6 47.9L67.5 55v-5.7l30.1-7v5.6zM68.2 54l28.7-6.8v-3.9L68.2 50v4z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M67.8 54.5l29.4-6.9v4.7l-29.4 7z" />
          <path
            d="M97.6 52.7l-30.1 7.2v-5.7l30.1-7.1v5.6zm-29.4 6.1L96.9 52v-3.9l-28.7 6.8v3.9z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M67.8 59.4l29.4-7v4.7l-29.4 7.1z" />
          <path
            d="M97.6 57.5l-30.1 7.2V59l30.1-7.2v5.7zm-29.4 6.2l28.7-6.9v-3.9l-28.7 6.8v4z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M67.8 64.2l29.4-7.1v4.8L67.8 69z" />
          <path
            d="M97.6 62.2l-30.1 7.3v-5.7l30.1-7.2v5.6zm-29.4 6.3l28.7-6.9v-3.9l-28.7 6.9v3.9z"
            fill="#fff"
          />
        </g>
        <path fill="#fff" d="M81.8 12.9l1.9-.5v52.8l-1.9.4z" />
      </g>
    </svg>
  );
};
